import { AppNS } from 'app';
import { object, string } from 'yup';

export interface FormValues {
  ticketType: AppNS.TicketType | '';
  subjectType: AppNS.SubjectType | '';
  parentTicketId: string;
  inspectorProfileId: string;
  inspectorId: string;
  companyId: string;
  disciplineForDeactivationId: string;
  documentIds: string[];
  deactivationScope: AppNS.DeactivationScope | '';
  description: string;
  isImmediateDeactivation: boolean;
  reviewerId: string;
  subject: string | null;
  deadline: string | null;
}

export const defaultValues: FormValues = {
  ticketType: '',
  subjectType: '',
  parentTicketId: '',
  inspectorProfileId: '',
  inspectorId: '',
  companyId: '',
  disciplineForDeactivationId: '',
  documentIds: [],
  deactivationScope: '',
  description: '',
  isImmediateDeactivation: false,
  reviewerId: '',
  subject: null,
  deadline: null,
};

const detailsFields = {
  subjectType: string().trim().required('Field is required'),
  ticketType: string().trim().required('Field is required'),
  description: string().trim().required('Field is required'),
  reviewerId: string().trim().required('Field is required'),
  deactivationScope: string()
    .trim()
    .when(['isImmediateDeactivation'], {
      is: true,
      then: () => string().trim().required('Scope is required when Immediate deactivation is picked.'),
    }),
  disciplineForDeactivationId: string()
    .trim()
    .when(['isImmediateDeactivation', 'deactivationScope'], {
      is: (isImmediateDeactivation: boolean, deactivationScope: string) => {
        return isImmediateDeactivation && deactivationScope === 'discipline';
      },
      then: () =>
        string()
          .trim()
          .required('Discipline is required when Immediate deactivation is picked and discipline scope is selected.'),
    }),

  subject: string().trim().nullable().required('Field is required'),
  deadline: string().trim().nullable().required('Field is required'),
};

export const getValidationSchema = () => {
  return object({
    ...detailsFields,
  });
};
